import styled from 'styled-components'
// components
import { Button } from 'components/UI'
import { Grid2 as Grid } from '@mui/material'
import CloseIconOrigin from '@mui/icons-material/CloseRounded'

export const Form = styled('form')`
  padding-left: 2px;
  margin: 0;
  display: flex;
  gap: 16px;
  align-items: center;

  svg {
    position: relative;
  }
`

export const CloseIcon = styled(CloseIconOrigin)`
  cursor: pointer;
`

export const AddButton = styled(Button)`
  text-transform: none;

  button {
    font-size: 12px;
    padding: 4px 8px;
    width: 100%;
  }
`

export const CreateButton = styled(Button)`
  && {
    button {
      border-radius: 22px;
      font-size: 18px;
      text-transform: none;
      max-width: unset;
    }
  }
`

export const FormContent = styled(Grid)`
  overflow: auto;
  padding-bottom: 4px;
  width: 100%;
`

export const InputWrapper = styled(Grid)`
  flex-grow: 1;
  margin-top: 10px;
`

export const ButtonsRow = styled(Grid)`
  margin-left: 2px;
`
